import secondaryComponents from "../../../../components/secondaryComponents";
import { motion } from "framer-motion";
import styles from "./styles.module.scss";
import { useNavigate } from "react-router-dom";
import globalStyles from "../../../../assets/styles/base/globalPage.module.scss";
import { useState } from "react";
import { pathConstants } from "../../../../routes/pathContants";
import {
  Connected,
  MarketPlaceComingSoonIcon,
} from "../../../../assets/svgIcons";
import appsData from "../../../../localdata/marketApps";
import { useSelector } from "react-redux";

const AllMarkets = () => {
  const navigate = useNavigate();
  const [selectedTableTab, setSelectedTableTab] = useState("All Apps");
  const tableTab = [
    { name: "All Apps" },
    { name: "Payments" },
    { name: "Services" },
    { name: "Accounting" },
    { name: "Socials" },
  ];
  const appList = appsData?.filter(
    (app) =>
      app?.categories.includes(selectedTableTab) ||
      selectedTableTab === "All Apps",
  );
  const { has_chowdeck_connection, has_squareup_connection } = useSelector(
    (state) => state.profileDetailsReducer.businessDetails,
  );
  const { businessDetails } = useSelector(
    (state) => state.profileDetailsReducer,
  );

  return (
    <secondaryComponents.MetaSetter
      title="Lumi Merchant | Markets"
      description="View all apps"
    >
      <secondaryComponents.RequestLoaderTrigger>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          className={`${styles.markets} ${globalStyles.pagePaddings} ${globalStyles.pageColumnGaps}`}
        >
          <div>
            <h4 className="mb-0">Connect Apps to Lumi Business</h4>
            <p>
              Connect apps to Lumi Business to streamline your workflow and
              boost efficiency.
            </p>
          </div>

          <div className={globalStyles.rowNavigations}>
            {tableTab?.map((item, index) => (
              // eslint-disable-next-line
              <a
                key={index}
                className={`${globalStyles.rowNavigations__item} ${
                  item?.name === selectedTableTab ? globalStyles.active : ""
                }`}
                onClick={() => {
                  setSelectedTableTab(item?.name);
                }}
              >
                <span key={index}>{item?.name}</span>
              </a>
            ))}
          </div>

          <div>
            {appList?.length > 0 ? (
              <div className={`${styles.markets__apps}`}>
                {appList?.map((app, index) => (
                  <motion.div
                    className={`${styles.markets__card}`}
                    key={index}
                    onClick={() => {
                      navigate(pathConstants.APPS_DETAILS({ id: app?.id }));
                    }}
                    whileHover={{ scale: 1.05 }}
                  >
                    {app.id === "vfd" ||
                    app.id === "chowdeck" ||
                    app.id === "squareup" ||
                    app.id === "paystackPOS" ? (
                      app.imageSrc
                    ) : (
                      <img
                        src={app.imageSrc}
                        alt={app.altText}
                        width={100}
                        height={100}
                        className="rounded mr-2"
                      />
                    )}
                    <div>
                      <h6>{app?.appName}</h6>
                      <p className="small-text-size mb-2">
                        {app?.short_description}
                      </p>
                      {(has_chowdeck_connection &&
                        app?.appName === "Chowdeck") ||
                      (has_squareup_connection &&
                        app?.appName === "Squareup") ||
                      app?.isConnected ||
                      (app?.isPaymentIntegration &&
                        businessDetails?.integrated_payment_providers?.includes(
                          app?.key,
                        )) ? (
                        <span
                          className={`d-flex align-items-center ${globalStyles.statusBlock} success--rounded py-2`}
                          style={{ width: "auto", maxWidth: "fit-content" }}
                        >
                          <Connected className="mr-1" /> Connected
                        </span>
                      ) : (
                        <span
                          className={`${globalStyles.statusBlock} purple white--text py-2`}
                          style={{ width: "auto", maxWidth: "fit-content" }}
                        >
                          Connect
                        </span>
                      )}
                    </div>
                  </motion.div>
                ))}
              </div>
            ) : (
              <div
                className="d-flex"
                style={{
                  flexDirection: "column",
                  alignItems: "center",
                  marginTop: "100px",
                }}
              >
                <MarketPlaceComingSoonIcon />
                <h5>Apps in this category are Coming Soon</h5>
                <p className="smallest-text-size">Explore other categories</p>
              </div>
            )}
          </div>
        </motion.div>
      </secondaryComponents.RequestLoaderTrigger>
    </secondaryComponents.MetaSetter>
  );
};
export default AllMarkets;
